import {Component, HostBinding, inject, OnDestroy} from '@angular/core';
import {RouterModule} from "@angular/router";
import {DxHttpModule} from "devextreme-angular/http";
import {ScreenService, ThemeService} from '@services';
import { locale } from "devextreme/localization";
import config from 'devextreme/core/config';
import {licenseKey} from '../devextreme-license';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [
        DxHttpModule,
        RouterModule,
    ]
})
export class AppComponent implements OnDestroy {
    @HostBinding('class') get getClass() {
        return Object.keys(this.screen.sizes).filter((cl) => this.screen.sizes[cl]).join(' ');
    }

    private themeService = inject(ThemeService);
    private screen = inject(ScreenService);

    constructor() {
        this.themeService.setAppTheme();
        locale('en-CA');
        config({ licenseKey: licenseKey });
    }

    ngOnDestroy(): void {
        this.screen.breakpointSubscription.unsubscribe();
    }
}
